import { useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { ArrowRight, Check } from "lucide-react";

const EMPTY = { name: "", email: "", phone: "", address: "", message: "" };

export function LeadForm({ dark = false, className = "" }) {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", { ...form, source: "homepage_lead" });
      setSent(true);
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setSending(false); }
  };

  const field = dark
    ? "w-full bg-transparent border-b border-white/30 focus:border-white text-white placeholder:text-white/45 text-sm py-2 outline-none transition-colors"
    : "w-full bg-transparent border-b border-white/25 focus:border-[#E5B869] text-white placeholder:text-white/35 text-sm py-2.5 outline-none transition-colors";

  if (sent) {
    return (
      <div data-testid="lead-success" className={`${className} text-white`}>
        <div className="flex items-center gap-3">
          <span className="h-8 w-8 flex items-center justify-center border border-white/40"><Check className="h-4 w-4" strokeWidth={1.5} /></span>
          <span className="font-display text-xl">Thank you.</span>
        </div>
        <p className="text-sm mt-3 text-white/70">We'll be in touch within one business day.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="lead-form" className={className}>
      <div className="eyebrow-light">Request a quote</div>
      <p className="text-sm mt-2 text-white/70">Tell us about your listing. We reply within one business day.</p>
      <div className={`${dark ? "mt-5 space-y-2" : "mt-6 space-y-3"}`}>
        <input data-testid="lead-name" required placeholder="Name" value={form.name} onChange={set("name")} className={field} />
        <input data-testid="lead-email" required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={field} />
        <input data-testid="lead-phone" placeholder="Phone" value={form.phone} onChange={set("phone")} className={field} />
        <input data-testid="lead-address" placeholder="Property address (optional)" value={form.address} onChange={set("address")} className={field} />
        <textarea data-testid="lead-message" rows={2} placeholder="Tell us about your listing — size, timeline, what you need" value={form.message} onChange={set("message")} className={`${field} resize-none`} />
      </div>
      <button data-testid="lead-submit" disabled={sending} className={`${dark ? "btn-light mt-5" : "btn-dark mt-7"} w-full disabled:opacity-60 group`}>
        {sending ? "Sending…" : "Send Request"}
        {!sending && <ArrowRight className="ml-2 h-3.5 w-3.5 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />}
      </button>
    </form>
  );
}
